import classnames from "classnames";
import React from "react";

// tslint:disable-next-line:no-var-requires
const style = require("./TitleButton.scss");

interface TitleButtonProps {
    readonly children: string;
    readonly enabled?: boolean;
    readonly className?: string;
    readonly onClick?: () => void;
    readonly btnLabelText?: string;
}

export default function TitleButton({
    children,
    onClick,
    className,
    enabled,
    btnLabelText
}: TitleButtonProps) {
    const hasLabelTxt = Boolean(btnLabelText && btnLabelText.trim());
    return (
        <button
            className={classnames(style.titleButton, className)}
            disabled={enabled === false}
            onClick={onClick}
        >
            {hasLabelTxt && (
                <div className={classnames(style.btnLabelTrapezoid, className)}>
                    <label>{btnLabelText}</label>
                </div>
            )}
            {children}
        </button>
    );
}
